import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

export interface ActiveUsersResponse {
  activeCount: number;
}

@Injectable({
  providedIn: 'root'
})
export class UserSessionService {
  constructor(private apiService: ApiService) {}

  /**
   * Récupère le nombre d'utilisateurs actuellement actifs
   * (actifs dans les 2 dernières minutes)
   */
  getActiveUsersCount(): Observable<ActiveUsersResponse> {
    return this.apiService.get<ActiveUsersResponse>('/labase/user-sessions/active-count');
  }
}
